import { setCookieShop, updateCookieShop } from './cookieShop'

export {
  setCookieShop,
  updateCookieShop
}
